<template>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-sm-12 text-center">
        <h2 class="mb-0">{{ text }}</h2>
      </div>
    </div>
  </div>
</template>
<script>
import routes from "../../router/index";

import { xray } from "../../config/pluginInit";

import validationService from "../../services/validation";

export default {
  name: "Validation",
  mounted() {
    xray.index();
    this.validate();
  },
  data() {
    return {
      text: "",
    };
  },
  methods: {
    async validate() {
      let self = this;

      this.$awn.asyncBlock(
        validationService.validate(this.$route.query.token),
        (response) => {
          if (response) {
            if (this.$route.query.mode === "CHANGE_PASSWORD") {
              routes.push({
                name: "public.newPassword",
                query: { token: this.$route.query.token },
              });
            } else {
              routes.push({
                name: "public.signin",
                query: { checkValidation: true },
              });
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "validationService.validate",
            module: "view-pages-validation",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              token: this.$route.query.token
            })
          });
        },
        " "
      );
    },
  },
};
</script>
